// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"798":"286b7ecf","995":"ecb8884a"}[chunkId] + ".css";
};